///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { GtthAbstractCommand } from '../../abstract-command';
import { ActivityDTO } from '../../../../../services/project-socket/activity-dto.model';
import { GtthRefreshTopologyCommand } from '../project/refresh-topology-command';
import { GtthPreloaderModalEvent } from '../../../../../shared/preloader-modal/preloader-modal-event';
import { GtthProgressWindowService } from '../../../../project-windows/progress-window/progress-window.service';

export class GtthActivateDesignIterationCommand extends GtthAbstractCommand {
    private iterationId: number;
    private previousIterationId: number;

    getCommandName(): string {
        return 'GtthActivateDesignIterationCommand';
    }

    create(iterationId: number): this {
        this.iterationId = iterationId;
        return this;
    }

    doCommand(): void {
        this.historyService.eventManager.broadcast({
            name: 'togglePreloaderModal',
            eventObject: GtthPreloaderModalEvent.show('Loading')
        });

        this.historyService.logicalTopology.isShowPlanningMode = false;

        this.historyService.bomReportService.clearBom().then((value) => {
            const activateIterationActivity = this.createActivityDTO(false);
            activateIterationActivity.previousDesignIterationNumber = this.historyService.logicalTopology.selectedDesignIteration;
            activateIterationActivity.designIterationNumber = this.iterationId;
            this.sendActivity(activateIterationActivity);
        });
    }

    doCommandActivity(activityDto: ActivityDTO): void {
        if (!activityDto.successful) {
            if (!this.handleUnsuccessfulActivity(activityDto)) {
                return;
            }
        }

        this.prepareForRefresh(activityDto);

        const refreshTopologyCommand = this.historyService.command(GtthRefreshTopologyCommand).create(false);
        this.historyService.doCommandBypassHistory(refreshTopologyCommand).then((refreshResult: boolean) => {
            this.handleRefreshResult(refreshResult, activityDto);
        });
    }

    private handleUnsuccessfulActivity(activityDto: ActivityDTO): boolean {
        this.historyService.notificationService.showError(activityDto?.error?.message);

        if (!activityDto.error.message.startsWith(GtthProgressWindowService.BU_DEVICE_ORIENTATION_COLLISION_ERROR)) {
            this.commandResolve?.(false);
            return false;
        }

        this.historyService.reportsService.setTopologyValidityToCache(activityDto.error.topologyValidity);
        setTimeout(() => {
            void this.historyService.router.navigate([{ outlets: { popup: `project-view/connected-sites` } }], { replaceUrl: true });
        }, 200);

        return true;
    }

    private prepareForRefresh(activityDto: ActivityDTO): void {
        this.previousIterationId = this.historyService.logicalTopology.selectedDesignIteration;
        this.historyService.logicalTopology.isShowPlanningMode = true;
        this.historyService.clearHistory();
    }

    private handleRefreshResult(refreshResult: boolean, activityDto: ActivityDTO): void {
        this.historyService.selectWholeTopologyLayer();
        this.historyService.logicalTopology.selectedDesignIteration = activityDto.designIterationNumber;
        this.historyService.logicalTopology.clearNodeNamesSectorsToShow();

        if (!this.commandResolve) {
            return;
        }

        if (!refreshResult) {
            this.commandResolve(false);
        } else {
            this.historyService.logicalTopology.setShowPlanningMode(this.historyService, true, true).then((result) => {
                this.commandResolve(result);
            });
        }
    }
}
